import { render, staticRenderFns } from "./gygl.vue?vue&type=template&id=5098ccb7&scoped=true&"
import script from "./gygl.vue?vue&type=script&lang=js&"
export * from "./gygl.vue?vue&type=script&lang=js&"
import style0 from "./gygl.vue?vue&type=style&index=0&id=5098ccb7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5098ccb7",
  null
  
)

export default component.exports